import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import settingsReducer from "./features/settings/settingsSlice.ts";
import appointmentReducer from "./features/appointment/appointmentSlice.ts";

export const store = configureStore({
  reducer: {
    settings: settingsReducer,
    appointment: appointmentReducer,
  },
  // Thunk is included by default in RTK, but if you add custom middleware, ensure it's included
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
    }).concat(/* other middlewares if any */),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, user: UsersState}
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
